import { SvgIcon } from "@mui/material";

const CustomHomeIcon = (props: any) => (
  <SvgIcon viewBox="0 3 24 24" {...props}>
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </SvgIcon>
);

export default CustomHomeIcon;
